import type { DynamicBlockElement } from '@aline/common';
import { buildRenderModel, Queries } from '@aline/common';
import type { Editor, NodeEntry } from 'slate';

export const editorTransforms = {
  setDynamicBlockCollapsed(
    editor: Editor,
    options: { dynamicBlockEntry: NodeEntry<DynamicBlockElement>; isCollapsed: boolean }
  ) {
    if (!editor.userState) return;

    const { dynamicBlockEntry, isCollapsed } = options;
    const [{ fieldId }] = dynamicBlockEntry;

    const expandedEmptyBlocks = new Set(Queries.getExpandedEmptyBlocks(editor));

    if (isCollapsed) {
      expandedEmptyBlocks.delete(fieldId);
    } else {
      expandedEmptyBlocks.add(fieldId);
    }

    editor.userState.expandedEmptyBlocks = expandedEmptyBlocks;

    /**
     * 1. We need to manually build the render model before onChange b/c editor.operations.length === 0 and the renderModel won't be rebuilt in onChange.
     * 2. Then call onChange last since we've rebuilt a bunch of rMDynamicBlocks and we want to re-render.
     */
    buildRenderModel(editor);
    editor.onChange();
  },
};
